import { render, staticRenderFns } from "./check_detail.vue?vue&type=template&id=1e70bbf5&scoped=true"
import script from "./check_detail.vue?vue&type=script&lang=js"
export * from "./check_detail.vue?vue&type=script&lang=js"
import style0 from "./check_detail.vue?vue&type=style&index=0&id=1e70bbf5&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e70bbf5",
  null
  
)

export default component.exports